<template>
  <div class="container">
    <ul class="todo-list">
      <li v-for="todo in todos">
        <p class="status">
          {{ todo.status ? "正常" : "故障" }}
          <span
            v-if="!todo.status && !todo.dealWith"
            @click="getTask(todo.terminal_id)"
            >收到</span
          >
        </p>
        <p class="step">处理状态：{{ todo.dealWith || "未受理" }}</p>
        <p class="time">报错时间：{{ todo.createAt }}</p>
        <p class="tag">机器类型：{{ todo.tags }}</p>
        <p class="location">地点：{{ todo.namecode }}</p>
        <p class="error">具体问题：{{ todo.errorMsg }}</p>
        <p class="help"><span @click="showHelp">帮助</span></p>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { getToDo, updateToDo } from "../../../../service";

export default {
  name: "todo",
  data() {
    return {
      todos: [],
      selected: "维护"
    };
  },
  methods: {
    ...mapMutations("tab", ["changeHelp", "changeTab"]),
    showHelp() {
      this.changeTab("个人中心");
      this.changeHelp(true);
    },
    async getList() {
      const { data } = await getToDo(this.tel);
      this.todos = data.data;
    },
    async getTask(id) {
      const {
        data: { code, msg }
      } = await updateToDo(id, this.tel);
      if (code === 0) {
        this.getList();
      } else {
        alert(msg);
      }
    },
    formatGetTime: function(date) {
      return new Date(date)
        .toLocaleString("chinese", { hour12: false })
        .slice(5, 19)
        .replace(/\//g, "-");
    }
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters({
      tel: "user/tel"
    }),
    status_text: () => {
      // this.sta
    }
  }
};
</script>

<style scoped lang="less">
.container {
  .todo-list {
    padding: 0;
    margin-bottom: 60px;
    li {
      list-style: none;
      text-align: left;
      border: 1px solid #e8e8e8;
      border-radius: 10px;
      padding: 0 20px;
      margin: 0 20px;
      margin-bottom: 20px;
      .status {
        span {
          float: right;
          border: 1px solid #e8e8e8;
          border-radius: 4px;
          padding: 2px 10px;
          font-size: 12px;
        }
      }
      .help {
        text-align: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/children/ToDo/index.vue